import React from 'react'
import { Controller } from "react-hook-form";
import {styles} from './styles';
import TitleCase from "react-title-case";
import { FormControl,  InputLabel, Select, FormHelperText, MenuItem } from "@material-ui/core";

export const SelectBasic = ({inputRef, label,  name, onChange, value, errors, maper, control}) => {
  const classes = styles();
    return (
        <FormControl variant="outlined" fullWidth  size="small" error={!!errors.hasOwnProperty(name) && errors[name].message} style = {{ background: '#ffffff'}}>
                  <InputLabel htmlFor="outlined-select-status" shrink={true}  size="small">{label}</InputLabel>
                  <Controller 
                  control={control}
                  as = {
                    <Select 
                    name = {name}
                    onChange={onChange}
                    // value={value}
                    fullWidth
                    inputRef={inputRef}
                    label ={label}
                    size="small"
                    margin="normal"
                    notched={true}
                    inputProps = {{
                        name: name,
                        id: `outlined-select-${name}`,
                      }} 
                    >
                          {(maper.array).map((x) => (
                           <MenuItem
                           className={classes.menuItem}
                           key={ maper?.key ? x[maper.key] : x}
                           value={maper?.value ? x[maper.value] : x}
                         >
                            <TitleCase string={maper?.show ? x[maper.show] : x} />
                         </MenuItem>
                            )
                          )}
                    </Select>
                  }
                  />
                   
                  <FormHelperText>{errors.hasOwnProperty(name) && errors[name].message}</FormHelperText>
                </FormControl>
    )
}

export const SelectWithoutValidation = ({inputRef, label, name, onChange, value,  maper}) => {
  const classes = styles();
  return (
      <FormControl variant="outlined" fullWidth size="small" >
                <InputLabel htmlFor="outlined-select-status" size="small" shrink={true}>{label}</InputLabel>
                  <Select  fullWidth
                    inputRef={inputRef}
                    label ={label}
                    notched={true}
                    className = {classes.dropdown}
                    size="small"
                    name = {name}
                    onChange={onChange}
                    inputProps = {
                        {
                            name: name,
                            id: `outlined-select-${name}`,
                        }
                    } 
                    value={value}
                    >
                           {(maper.array).map((x) => (
                           <MenuItem
                           className={classes.menuItem}
                           key={ maper?.key ? x[maper.key] : x}
                           value={maper?.value ? x[maper.value] : x}
                         >
                            <TitleCase string={maper?.show ? x[maper.show] : x} />
                         </MenuItem>
                            )
                          )}
                  </Select>
              </FormControl>
  )
}

export const SelectPosition = ({label, name, onChange, value, message, error, maper}) => {
  const classes = styles();
    return (
        <FormControl variant="outlined" fullWidth  size="small"  >
                  <InputLabel htmlFor="outlined-select-status"  size="small">{label}</InputLabel>
                    <Select 
                    fullWidth
                    label={label}
                    value={value}
                    className = {classes.dropdown}
                    onChange={onChange}
                    error={ error }
                    name={name}
                    inputProps={{
                        name: name,
                        id: 'outlined-select-position',
                    }}
                      >
                          {(maper.array).map((x) => (
                           <MenuItem
                           className={classes.menuItem}
                           key={ maper?.key ? x[maper.key] : x}
                           value={maper?.value ? x[maper.value] : x}
                         >
                          <TitleCase string={maper?.show ? x[maper.show] : x} />
                         </MenuItem>
                            )
                          )}
                    </Select>
                  <FormHelperText error={error}>{error && message}</FormHelperText>
                </FormControl>
    )
}




